// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R17gL","icon":"styles_icon__TpfFD"};